import Header from "./components/Header";
import Hero from "./components/Hero";
import Tariffs from "./components/Tariffs";
import Footer from "./components/Footer";

function App() {
  return (
    <>
      <Header />
      <Hero />
      <Tariffs />
      <Footer />
    </>
  );
}

export default App;
